import React, { useState } from 'react';
import styles from './index.module.scss';
import sgmService from '../../../services/sgmService';

const DEFAULT_MONTHLY_LIMIT = 2100;

const PointLimitComponent = ({ limit, remaining, onClose }) => {
  const [isSending, setIsSending] = useState(false);
  const [hasRequestError, setHasRequestError] = useState(false);

  const monthlyLimit =
    Number.isFinite(limit) && limit > 0 ? limit : DEFAULT_MONTHLY_LIMIT;
  const hasRemaining = Number.isFinite(remaining) && remaining > 0;

  const callRequestClick = async () => {
    if (isSending) return;

    try {
      setIsSending(true);
      setHasRequestError(false);

      await sgmService.createCallbackRequest();

      onClose();
    } catch (e) {
      setHasRequestError(true);
      setIsSending(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.backdrop} onClick={onClose} />
      <div className={styles.sheet}>
        <div className={styles.textBlock}>
          <p className={styles.title}>
            Ви використали місячний ліміт балів — {monthlyLimit}
          </p>
          <p className={styles.description}>
            {hasRemaining
              ? `Цього місяця ви можете обміняти ще ${remaining} балів.`
              : 'На жаль, цього місяця ви вже використали всі доступні бали.'}
          </p>
        </div>
        <div className={styles.textBlock}>
          <p className={styles.title}>Хочете продовжити?</p>
          <p className={styles.description}>
            Натисніть кнопку нижче — наш торговий представник зв’яжеться з вами.
          </p>
        </div>
        <div className={styles.actionBlock}>
          <p className={styles.note}>
            Або дочекайтеся оновлення ліміту наступного місяця та продовжуйте
            використовувати бали.
          </p>
          <button
            className={styles.mainButton}
            onClick={callRequestClick}
            disabled={isSending}
            style={isSending ? { opacity: 0.6 } : undefined}
          >
            {isSending ? 'Надсилаємо...' : 'Зателефонувати мені'}
          </button>
          {hasRequestError && (
            <p className={styles.errorText}>
              Не вдалося надіслати запит. Спробуйте ще раз.
            </p>
          )}
        </div>
        <p className={styles.closeButton} onClick={onClose}>
          Закрити
        </p>
      </div>
    </div>
  );
};

export default PointLimitComponent;
